import React from 'react';
import * as Styled from './styled';
import { useLocale } from 'locale';
import Modal from 'ds/components/modal';
import useAnchorLink from 'hooks/useAnchorLink';
import { Button } from 'ds/components/button';
import { SmartText, H3 } from 'ds/components/typography';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { DecodedRouteParams, Route } from 'config/routes';
import { NavigationOptions } from 'store/state/router/actionPayloads';


interface YieldModalProps {
  poiId: string | null;
  routeName: Route;
  routeParams: DecodedRouteParams;
  onClose: () => void;
  navigate: (name: Route, params?: DecodedRouteParams, opts?: NavigationOptions) => void;
}

export const YieldModal: React.FC<YieldModalProps> = props => {
  const { poiId, onClose, navigate, routeName, routeParams } = props;
  const { t } = useLocale();
  const termHref = useAnchorLink('/etc/terms');
  const breakpoint = useScreenBreakpoint();
  const isMobile = breakpoint <= 2;

  if (!poiId) return null;

  const handleButtonClick = () => {
    switch (routeName) {
      case Route.Search:
        navigate(Route.UnitPage, { ...routeParams, id: poiId }, { openInNewTab: !isMobile });
        break;
      case Route.InvestorsSearchPage:
        navigate(Route.UnitPage, { ...routeParams, id: poiId, investorMode: true }, { openInNewTab: false });
        break;
      default:
        break;
    }
    onClose();
  };

  return (
    <Modal
      isOpen={Boolean(poiId)}
      onClose={onClose}
      mobileModalPositionBottom
      desktopModalPositionCenter
    >
      <Styled.Root>
        <H3 weight="bold">{t('widget.yield.popup.header')}</H3>
        <SmartText small={isMobile}>{t('widget.yield.popup.line1')}</SmartText>
        <SmartText small={isMobile}>{t('widget.yield.popup.line2')}</SmartText>
        <SmartText small={isMobile}>
          {t('widget.yield.popup.line3')}
          <a href={termHref} target="_blank" rel="nofollow">
            {t('widget.yield.popup.link')}
          </a>
        </SmartText>
        <Button mode="primary" size="extraLarge" onClick={handleButtonClick} fullWidth>
          {t('widget.yield.popup.accept')}
        </Button>
      </Styled.Root>
    </Modal>
  );
};
